import { DEFAULT_FACET_TYPE } from '../../../types.js';
/**
 * Search for a facet in a Response
 * @param response
 * @param facetId
 */
function findFacetOnResponse(response, facetId) {
    return response?.facet?.find(({ name }) => name === facetId);
}
/**
 * Returns a SearchResponseFacetItem if it matches with a value id.
 * @param response
 * @param facetId
 * @param valueId
 */
function findFacetValueOnResponseByValueId(response, facetId, valueId) {
    const facet = findFacetOnResponse(response, facetId);
    if (facet) {
        return facet.value.find(({ id }) => valueId === id);
    }
    return undefined;
}
/**
 * Validates if an object matches with a range structure.
 * @param obj
 */
function isRange(obj) {
    return 'max' in obj || 'min' in obj;
}
/**
 * Returns the config type of a facet by its id.
 * @param facetsConfig
 * @param facetId
 */
function getFacetConfigType(facetsConfig, facetId) {
    const { facets = {} } = facetsConfig;
    const { type } = facets[facetId] || {};
    return type || facetsConfig.defaultFacetType || DEFAULT_FACET_TYPE;
}
/**
 * Validates if a SearchResultsStoreSelectedFacet matches with a response facet item.
 * @param item
 * @param facetItem
 */
const findItemInResponse = (item, facetItem) => ('facetValueId' in facetItem && item.id === facetItem.facetValueId) ||
    ('facetValueText' in facetItem && item.text === facetItem.facetValueText);
/**
 * Returns the index of the selected facet that matches the facetId and facetValueId provided.
 * @param selectedFacets
 * @param facetId
 * @param facetValueId
 */
function findSelectedFacetValueIndex(selectedFacets, facetId, facetValueId) {
    return selectedFacets.findIndex((item) => {
        const itemToCompare = item;
        return facetValueId && itemToCompare.facetId === facetId && itemToCompare.facetValueId === facetValueId;
    });
}
function findSelectedFacetTextIndex(selectedFacets, facetId, facetValueId, response) {
    if (typeof facetValueId !== 'undefined') {
        const facetResponseItem = findFacetValueOnResponseByValueId(response, facetId, facetValueId);
        if (facetResponseItem) {
            return selectedFacets.findIndex((item) => {
                const itemToCompare = item;
                return itemToCompare.facetId === facetId && itemToCompare.facetValueText === facetResponseItem.text;
            });
        }
    }
    return -1;
}
export { findSelectedFacetTextIndex, findSelectedFacetValueIndex, isRange, findFacetOnResponse, findFacetValueOnResponseByValueId, getFacetConfigType, findItemInResponse, };
